import { render } from "./PlanStatusTag.vue?vue&type=template&id=8f6c4430"
import script from "./PlanStatusTag.vue?vue&type=script&lang=js"
export * from "./PlanStatusTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__